<template>
  <ChangeToBusinessForm
    v-if="authorize == 'merchant'"
    ref="ChangeToBusinessForm"
  />
</template>

<script>
import Toolbar from '@/view/layout/header/Toolbar.vue';
import ChangeToBusinessForm from '../components/ChangeToBusinessForm.vue';
import roleMiddlewaresMixin from '@/core/mixins/roleMiddlewaresMixin';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      EventBus: null,
    };
  },
  mixins: [roleMiddlewaresMixin],
  computed: {
    ...mapGetters(['authorize']),
  },

  components: {
    Toolbar,
    ChangeToBusinessForm,
  },
  methods: {
    saveHandler() {
      // save has Defined In Child Component
      this.$refs['ChangeToBusinessForm'].save();
    },
    newHandler() {
      this.$refs['ChangeToBusinessForm'].new();
    },
    listHandler() {
      this.$refs['ChangeToBusinessForm'].showList();
    },
    returnToList() {
      this.$refs['ChangeToBusinessForm'].returnToList();
    },
  },
};
</script>

<style></style>
